export const ALLERGIES_URL = '/api/pet/null/allergies';

export const getPlaceholderAllergies = (count = 8) =>
  Array.from({ length: count }, (val, idx) => ({
    ...val,
    name: 'Loading',
    id: `Loading-${idx}`,
  }));
